import { DefaultFormLayout } from "src/components/Form/DefaultFormLayout.tsx";
import React, { type CSSProperties } from "react";
import type { ValidFormLayoutConfig } from "src/system/module.types.ts";
import type { FieldValues } from "react-hook-form";

export const ResourceFormLayout = <
  FormValues extends FieldValues = FieldValues,
>({
  className,
  style,
  config,
  onResetQueryError,
}: {
  className?: string;
  style?: CSSProperties;
  config: ValidFormLayoutConfig<FormValues>;
  onResetQueryError?: () => void;
}) => {
  if ("type" in config) {
    return <config.Component />;
  }
  return (
    <DefaultFormLayout
      onResetQueryError={onResetQueryError}
      config={config}
      className={className}
      style={style}
    />
  );
};
